/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import clsx from 'clsx';

import { Input } from '@atoms';
import { Form } from '@organisms';

import s from './styles.module.less';

const NumberField = ({ disabled, formatter, parser, controls = true, ...props }) => {
  return (
    <Form.Item {...props}>
      <Input.Number
        disabled={disabled}
        formatter={formatter}
        parser={parser}
        className={clsx({ [s.disableControls]: !controls })}
      />
    </Form.Item>
  );
};

export default NumberField;
